import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AudioProvider } from './context/AudioContext';
import { SecurityProvider } from './context/SecurityContext.jsx';
import { applyElectronStyles } from './utils/electronUtils';

// Apply Electron-specific styles
applyElectronStyles();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SecurityProvider>
    <AudioProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AudioProvider>
  </SecurityProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
